import { render, staticRenderFns } from "./GeneralSettingsTaxesDiscountAfterTax.vue?vue&type=template&id=3752fba0&"
import script from "./GeneralSettingsTaxesDiscountAfterTax.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsTaxesDiscountAfterTax.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports